export class InvQueryViewModel {
  StartDate: string;
  EndDate: string;
  Status: string[] = [];
  OrgId?: number;
  OrgIds?: number[] = [];
  ComparisonOrgIds?: number[] = [];
  ItemId?: number;
}
